
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5517',
  depVersions: {
  "data-privacy-request-ui": "static-1.5517",
  "data-fetching-client": "static-1.9659",
  "head-dlb": "static-1.4994",
  "hs-test-utils": "static-1.8001",
  "hub-http-shared-msw-handlers": "static-1.9923",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11458",
  "I18n": "static-7.1621",
  "jasmine-runner": "static-1.6454",
  "privacy-center-public-service-types": "static-1.4780",
  "quartz": "static-1.7016",
  "react-dlb": "static-1.78",
  "ui-components-test-utils": "static-1.5595",
  "UIComponents": "static-3.8404",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.85",
  "foundations-assets": "static-1.4853",
  "foundations-components": "static-1.7905",
  "foundations-components-test-utils": "static-1.5388",
  "foundations-theming": "static-1.4406",
  "hub-http": "static-1.6211",
  "quartz-config": "static-1.794",
  "quartz-core": "static-1.6235",
  "quartz-routing": "static-1.446",
  "quick-fetch": "static-1.3906",
  "raven": "static-3.5907",
  "react": "static-7.185",
  "react-rhumb": "static-1.16655",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11139",
  "usage-tracker": "static-1.7332",
  "usage-tracker-anonymous": "static-1.5749",
  "usage-tracker-core": "static-1.7182",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "PortalIdParser": "static-2.397",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9619",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3390",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3293",
  "quartz-webpack": "static-1.3240",
  "bend-plugin-quartz-routing": "static-1.94",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.81",
  "HeadJS": "static-2.757",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3112",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "ts-schema": "static-1.4070",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "react-utils": "static-2.5334",
  "StyleGuideUI": "static-3.486",
  "jasmine": "static-4.4315",
  "rpc-client-utils": "static-1.4638",
  "HubStyle": "static-2.11765",
  "ui-addon-draggable": "static-3.4753",
  "cssUtils": "static-1.787",
  "hs-story-utils": "static-1.9415",
  "icons": "static-2.645",
  "react-select-plus": "static-1.104",
  "react-virtualized": "static-2.98",
  "ui-images": "static-2.1150",
  "bend-plugin-foundations-components": "static-1.4174",
  "floating-ui": "static-1.55",
  "foundations-theming-specialty": "static-1.2122",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.19",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1873",
  "ui-fonts": "static-1.720",
  "foundations-components-legacy": "static-1.930",
  "bend-plugin-foundations-theming": "static-1.2889",
  "foundations-theming-base": "static-1.3391",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.71",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4642",
  "mobile-manifest-mixins": "static-1.532",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1.691",
  "quartz-head": "static-1.681",
  "quartz-i18n": "static-1.691",
  "quartz-test": "static-1.691",
  "quartz-tracking": "static-1.395",
  "usage-tracker-container": "static-1.7322",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.3186",
  "bend-plugin-chirp-manifest": "static-1.48",
  "chirp-fetch": "static-1.1873",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.69",
  "sassPrefix": "static-1.155",
  "hubspotter-http-shared-msw-handlers": "static-1.9921",
  "usage-tracker-session-replay": "static-1.5018",
  "amplitude-session-replay-browser": "static-1.59"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5517",
  "data-fetching-client": "/data-fetching-client/static-1.9659",
  "head-dlb": "/head-dlb/static-1.4994",
  "hs-test-utils": "/hs-test-utils/static-1.8001",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9923",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11458",
  "I18n": "/I18n/static-7.1621",
  "jasmine-runner": "/jasmine-runner/static-1.6454",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4780",
  "quartz": "/quartz/static-1.7016",
  "react-dlb": "/react-dlb/static-1.78",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5595",
  "UIComponents": "/UIComponents/static-3.8404",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "foundations-assets": "/foundations-assets/static-1.4853",
  "foundations-components": "/foundations-components/static-1.7905",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5388",
  "foundations-theming": "/foundations-theming/static-1.4406",
  "hub-http": "/hub-http/static-1.6211",
  "quartz-config": "/quartz-config/static-1.794",
  "quartz-core": "/quartz-core/static-1.6235",
  "quartz-routing": "/quartz-routing/static-1.446",
  "quick-fetch": "/quick-fetch/static-1.3906",
  "raven": "/raven/static-3.5907",
  "react": "/react/static-7.185",
  "react-rhumb": "/react-rhumb/static-1.16655",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11139",
  "usage-tracker": "/usage-tracker/static-1.7332",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5749",
  "usage-tracker-core": "/usage-tracker-core/static-1.7182",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9619",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3390",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3293",
  "quartz-webpack": "/quartz-webpack/static-1.3240",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.94",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.81",
  "HeadJS": "/HeadJS/static-2.757",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3112",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "ts-schema": "/ts-schema/static-1.4070",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "react-utils": "/react-utils/static-2.5334",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "jasmine": "/jasmine/static-4.4315",
  "rpc-client-utils": "/rpc-client-utils/static-1.4638",
  "HubStyle": "/HubStyle/static-2.11765",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4753",
  "cssUtils": "/cssUtils/static-1.787",
  "hs-story-utils": "/hs-story-utils/static-1.9415",
  "icons": "/icons/static-2.645",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-virtualized": "/react-virtualized/static-2.98",
  "ui-images": "/ui-images/static-2.1150",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4174",
  "floating-ui": "/floating-ui/static-1.55",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2122",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.19",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1873",
  "ui-fonts": "/ui-fonts/static-1.720",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.930",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2889",
  "foundations-theming-base": "/foundations-theming-base/static-1.3391",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.71",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4642",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.532",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1.691",
  "quartz-head": "/quartz-head/static-1.681",
  "quartz-i18n": "/quartz-i18n/static-1.691",
  "quartz-test": "/quartz-test/static-1.691",
  "quartz-tracking": "/quartz-tracking/static-1.395",
  "usage-tracker-container": "/usage-tracker-container/static-1.7322",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.3186",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.48",
  "chirp-fetch": "/chirp-fetch/static-1.1873",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.69",
  "sassPrefix": "/sassPrefix/static-1.155",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9921",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5018",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59"
}
};
